import { create } from "@/lib/zustand";
import { Voc } from "@/models/Voc";

interface KeywordSearchState {
  isLoading: boolean;
  vocs?: Voc[];
  keyword?: string;
  total?: number;
  setIsLoading: (isLoading: boolean) => void;
  setVocs: (vocs: Voc[]) => void;
  setKeyword: (keyword: string) => void;
  setTotal: (total: number) => void;
}

export const useKeywordSearchStore = create<KeywordSearchState>()(
  (set) => ({
    isLoading: false,
    setIsLoading: (isLoading: boolean) => set((_) => ({ isLoading })),
    setVocs: (vocs: Voc[]) => set((_) => ({ vocs })),
    setKeyword: (keyword: string) => set((_) => ({ keyword })),
    setTotal: (total: number) => set((_) => ({ total })),
  }),
);
